import { getAttributionExpiry, hasRecoveryData, saveRecovery } from "../data";
import { AdBlockerType, SoftwallRecoveredType } from "../types";
import { appendKVPToAdRequest, sendEvent, isExpired } from "../utils";

export const onRecover = (
  recovered: SoftwallRecoveredType,
  detectedExtension: AdBlockerType,
) => {
  // get expiration time if already set or get new one based on attribution window
  const attributionExpiry = getAttributionExpiry();
  if (recovered === "AB" && !isExpired(attributionExpiry)) {
    appendKVPToAdRequest();
  }

  if (!hasRecoveryData()) {
    saveRecovery(recovered);

    sendEvent({
      event: "recovered",
      recoveryType: recovered,
      detectedExtension,
    });
  }
};
